module.exports = __webpack_public_path__ + "assets/b1888361dcb9d67d5f731bb8b66ec072.mp3";